declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData, AutoGenBool, AutoGenList, AutoGenListH } from '../../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-listh',
    templateUrl: './autogenlisth.component.html',
    styleUrls: ['./autogenlisth.component.scss']
})

export class AutoGenListHComponent implements OnInit {
    @Input() public mode;
    @Input() public Data: AutoGenListH;
    @Input() public field: FieldData;

    get isChecked(): boolean {
        if (!this.field || this.field.Value == null) return false;
        const val = String(this.field.Value).trim().toLowerCase();
        return val === 'true' || val === '1' || val === 'yes' || val === 't';
    }

    @Input('isChecked')
    set isChecked(value: boolean) {
        if (this.field != null) {
            this.field.Value = value ? 'True' : 'False';
        }
    }

    get isTrue(): boolean {
        return this.isChecked;
    }

    ngOnInit(): void {
    }
}
